import React, { ReactElement } from "react";
import Grid from "@mui/material/Grid";
import { Typography, Link, IconButton, Tooltip, Box } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CopyToClipboard from "react-copy-to-clipboard";
import { useAlert } from "../contexts/alert/useAlert";
import { GameState } from "./Room";



interface PlayerMessagingProps {
    state: GameState;
    isModerator: boolean;
}

export default function GameStateMessage(props: PlayerMessagingProps): ReactElement {

    const roomUrl = window.location.href;
    const alert = useAlert();

    function renderWaiting() {
        return (
            <Grid container sx={{ marginBottom: 3, maxWidth: 600, paddingLeft: { sm: 4 }, paddingRight: { sm: 4 } }} spacing={3} direction="column" justifyContent="space-between" alignItems="center" wrap="nowrap">
                <Grid sx={{ maxWidth: 500 }}>
                    <Typography align="center" variant="h5">
                        {props.isModerator ? "Invite players to the room" : "Wait for the moderator to start the session"}
                    </Typography>
                    <Typography align="center" variant="subtitle1">
                        Send the link below to your team mates and soon they will start joining the room
                    </Typography>
                </Grid>
                <Grid>
                    <Link sx={{ color: 'link.main' }} variant="body1">
                        {roomUrl}
                    </Link>
                    <CopyToClipboard text={roomUrl} onCopy={() => alert.showMessage("Room link is now copied to the clipboard 👍", "success")}>
                        <Tooltip title="Copy Room Link" aria-label="Copy Room Link">
                            <IconButton sx={{ color: 'icon.main' }}>
                                <FileCopyIcon />
                            </IconButton>
                        </Tooltip>
                    </CopyToClipboard>
                </Grid>
                {props.isModerator ? (
                    <Grid sx={{ maxWidth: 500 }}>
                        <Typography variant="body2" align="center">
                            You are the moderator and are in control of the estimation session. Press &quot;Start&quot; when all players has joined the room 🚀.
                        </Typography>
                    </Grid>
                ) : (
                    <Grid sx={{ maxWidth: 500 }}>
                        <Typography variant="body2" align="center">
                            When the moderator starts the game your planning poker card deck will appear and the estimation session can begin. In the meanwhile
                            this is the perfect time to go grap a cup of coffee ☕
                        </Typography>
                    </Grid>
                )}
            </Grid>
        );
    }
    function renderSuspended() {
        return (
            <Grid container sx={{ marginBottom: 3, maxWidth: 600, paddingLeft: { sm: 4 }, paddingRight: { sm: 4 } }} spacing={3} direction="column" justifyContent="space-between" alignItems="center" wrap="nowrap">
                <Grid sx={{ maxWidth: 500 }}>
                    <Typography align="center" variant="h5">
                        I hope you have enjoyed the free trial 🙏
                    </Typography>
                    <Typography align="center" variant="subtitle1">
                        But for now your room is suspended 😞
                    </Typography>
                </Grid>
                <Grid>
                    <Link sx={{ color: 'link.main' }} variant="body1">
                        {roomUrl}
                    </Link>
                    <CopyToClipboard text={roomUrl} onCopy={() => alert.showMessage("Room link is now copied to the clipboard 👍", "success")}>
                        <Tooltip title="Copy Room Link" aria-label="Copy Room Link">
                            <IconButton sx={{ color: 'icon.main' }}>
                                <FileCopyIcon />
                            </IconButton>
                        </Tooltip>
                    </CopyToClipboard>
                </Grid>
                <Grid sx={{ maxWidth: 500 }}>
                    <Typography variant="body1" align="center">
                        In order to reactivate this room one of you needs to have an active account. So please consider the{" "}
                        <Link underline="always" target="_blank" href="https://storypoint.poker/#prices" color="inherit">
                            Business Subscription
                        </Link>
                        . If you have any questions feel free to contact us at support@storypoint.poker.
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    return (
        <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "center" }}>
            {props.state == GameState.WaitingForPLayers && renderWaiting()}
            {props.state == GameState.Suspended && renderSuspended()}
        </Box>
    );
}
